import type { SVGProps } from "react";
const SvgFilledCross = (props: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.89062 0.5C12.0381 0.5 15.3906 3.8525 15.3906 8C15.3906 12.1475 12.0381 15.5 7.89062 15.5C3.74312 15.5 0.390625 12.1475 0.390625 8C0.390625 3.8525 3.74312 0.5 7.89062 0.5ZM10.5831 4.25L7.89062 6.9425L5.19812 4.25L4.14062 5.3075L6.83313 8L4.14062 10.6925L5.19812 11.75L7.89062 9.0575L10.5831 11.75L11.6406 10.6925L8.94812 8L11.6406 5.3075L10.5831 4.25Z" fill="#C8C8C8"/>
    </svg>
    
    

);
export default SvgFilledCross;